import { assocPath } from '../utils/fp';
import { RESET_SEARCH } from './search';

//---------------------------------------------------------------------------------------------model
const model = () => ({
  attributes: [],
  constraints: {},
  constraintId: undefined,
  dimensions: [],
  data: undefined,
  hiddenValuesAnnotation: {},
  page: 0,
  timePeriod: undefined,
  externalReference: undefined,
  name: undefined,
  hierarchies: {},
  isDataUrlTooLong: false,
  isApiQueryCopied: false,
  parsedAttributes: undefined,
  microdataDimensionId: undefined,
  combinationsDefinition: undefined,
  actualContentConstraints: [],
  constraintAttributes: {},
  customDataRequestSize: null,
});

//-----------------------------------------------------------------------------------------constants
export const HANDLE_STRUCTURE = '@@sdmx/HANDLE_STRUCTURE';
export const HANDLE_DATA = '@@sdmx/HANDLE_DATA';
export const FLUSH_DATA = '@@sdmx/FLUSH_DATA';
const FLUSH_STRUCTURE = '@@sdmx/FLUSH_STRUCTURE';
export const REQUEST_CSV_DATAFILE = '@@sdmx/REQUEST_CSV_DATAFILE';
export const CHANGE_DATAFLOW = '@@sdmx/CHANGE_DATAFLOW';
export const RESET_DATAFLOW = '@@sdmx/RESET_DATAFLOW';
export const CHANGE_DATAQUERY = '@@sdmx/CHANGE_DATAQUERY';
export const CHANGE_FREQUENCY_PERIOD = '@@sdmx/CHANGE_FREQUENCY_PERIOD';
export const HANDLE_EXTERNAL_REFERENCE = '@@sdmx/HANDLE_EXTERNAL_REFERENCE';
export const HANDLE_AVAILABLE_TIME_PERIOD = '@@sdmx/HANDLE_AVAILABLE_TIME_PERIOD';
const IS_DATA_URL_TOO_LONG = `@@sdmx/IS_DATA_URL_TOO_LONG`;
const COPY_API_QUERY = `@@sdmx/COPY_API_QUERY`;
export const CHANGE_FREQUENCY_PERIOD_DATAQUERY = '@@sdmx/CHANGE_FREQUENCY_PERIOD_DATAQUERY';
const CHANGE_PAGE = '@@sdmx/CHANGE_PAGE';
const CHANGE_CONSTRAINT_ID = '@@sdmx/CHANGE_CONSTRAINT_ID';
export const CHANGE_FREQUENCY_PERIOD_DATAQUERY_F = '@@sdmx/CHANGE_FREQUENCY_PERIOD_DATAQUERY_F';

//------------------------------------------------------------------------------------------creators
export const requestCsvDataFile = ({ filename }) => ({
  type: REQUEST_CSV_DATAFILE,
  payload: { filename },
});

export const dataUrlIsTooLong = () => ({ type: IS_DATA_URL_TOO_LONG });
export const copyApiQuery = () => ({ type: COPY_API_QUERY });
export const changeConstraintId = constraintId => ({
  type: CHANGE_CONSTRAINT_ID,
  payload: { constraintId },
});

export const changePage = page => ({
  type: CHANGE_PAGE,
  page,
});

//-------------------------------------------------------------------------------------------reducer
export default (state = model(), action = {}) => {
  switch (action.type) {
    case CHANGE_CONSTRAINT_ID:
      return { ...state, constraintId: action.payload.constraintId };
    case IS_DATA_URL_TOO_LONG:
      return { ...state, isDataUrlTooLong: true };
    case FLUSH_DATA:
      return { ...state, data: undefined, parsedAttributes: undefined };
    case HANDLE_EXTERNAL_REFERENCE:
      return { ...state, externalReference: action.externalReference };
    case HANDLE_STRUCTURE:
      return { ...state, ...action.structure, page: 0 };
    case HANDLE_AVAILABLE_TIME_PERIOD:
      return {
        ...state,
        constraints: { ...state.constraints, ...action.constraints },
      };
    case HANDLE_DATA:
      return { ...state, ...action.data };
    case COPY_API_QUERY:
      return { ...state, isApiQueryCopied: true };
    case RESET_SEARCH:
    case RESET_DATAFLOW:
    case FLUSH_STRUCTURE:
    case CHANGE_DATAFLOW:
      return { ...state, ...model() };
    case CHANGE_DATAQUERY:
      return assocPath(['constraints', 'availableTimePeriod'], null, { ...state, page: 0 });
    case CHANGE_FREQUENCY_PERIOD:
    case CHANGE_FREQUENCY_PERIOD_DATAQUERY:
    case CHANGE_FREQUENCY_PERIOD_DATAQUERY_F:
      return { ...state, page: 0 };
    case CHANGE_PAGE:
      return { ...state, page: action.page };
    default:
      return state;
  }
};
